// 获取cookies
export function getCookie(name) {
  const cookies = document.cookie.split("; ");
  for (const cookie of cookies) {
    const [key, value] = cookie.split("=");
    if (key === name) {
      return decodeURIComponent(value); // 解码特殊字符
    }
  }
  return null;
}

// 设置cookies
// secure 默认按当前页面协议自动判定：HTTPS 页面自动附加 Secure 标志（HTTP 环境如本地开发不附加，避免 Cookie 失效）
export function setCookie(
  name,
  value,
  days = 100,
  path = "/",
  domain,
  secure = window.location.protocol === "https:",
  sameSite = "Lax"
) {
  let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

  // 过期时间
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    cookieString += `; expires=${date.toUTCString()}`;
  }

  cookieString += `; path=${path}`;
  if (domain) cookieString += `; domain=${domain}`;
  if (secure) cookieString += `; secure`;
  if (sameSite) cookieString += `; samesite=${sameSite}`;

  document.cookie = cookieString;
}
